/**
 * UI配置模块枚举
 * 使用 TypeScript enum 定义各个模块的标识和名称
 */

import { t } from '@/i18n'

/**
 * 模块枚举
 */
export enum UiConfigModule {
  /** 整箱运价管理 */
  FCL_RATE = 100,
  /** 港前运价管理 */
  PREPORT_RATE = 102,
  /** 尾程运价管理 */
  LAST_MILE_RATE = 116,
  /** 电商运价管理 */
  ECOMMERCE_RATE = 117,
  /** 空运运价管理 */
  AIR_RATE = 118,
  /** 拼箱运价管理 */
  LCL_RATE = 119,
  /** 快递运价管理 */
  EXPRESS_RATE = 120,
  /** 铁路运价维护 */
  RAIL_RATE = 118000,
  /** 运价查询 */
  RATE_QUERY = 103,
  /** 询价管理 */
  INQUIRY = 104,
  /** 报价管理 */
  QUOTE = 105,
  /** 附加费管理 */
  SURCHARGE = 106,
  /** 定价规则管理 */
  PRICING_RULE = 107,
  /** 合同管理 */
  CONTRACT = 108,
  /** 订单管理 */
  ORDER = 109,
  /** 订单详情 */
  ORDER_DETAIL = 110,
  /** 订单询价 */
  ORDER_INQUIRY = 111,
  /** 用户管理 */
  USER = 112,
  /** 公司管理 */
  COMPANY = 113,
  /** 权限管理 */
  PERMISSION = 114,
  /** 表格配置模块 (200-299) */
  FCL_RATE_TABLE = 200,
  LCL_RATE_TABLE = 201,
  AIR_RATE_TABLE = 202,
  PREPORT_RATE_TABLE = 203,
  LAST_MILE_RATE_TABLE = 210,
  ONCARRIAGE_RATE_TABLE = 204,
  INQUIRY_TABLE = 205,
  ORDER_TABLE = 206,
  USER_TABLE = 207,
  COMPANY_TABLE = 208,
  BILLING_TABLE = 209,
  FCL_INQUIRY_TABLE = 215, // 修复：从210改为215避免与LAST_MILE_RATE_TABLE重复
  LCL_INQUIRY_TABLE = 211,
  AIR_INQUIRY_TABLE = 229,
  PREPORT_INQUIRY_TABLE = 213,
  LASTMILE_INQUIRY_TABLE = 214,
  FCL_QUOTATION_TABLE = 216,
  LCL_QUOTATION_TABLE = 217,
  AIR_QUOTATION_TABLE = 218,
  PREPORT_QUOTATION_TABLE = 219,
  LAST_MILE_QUOTATION_TABLE = 220,
  /** 快递运价管理表格 */
  EXPRESS_RATE_TABLE = 222,
  /** 快递询价管理表格 */
  EXPRESS_INQUIRY_TABLE = 223,
  /** 铁路询价管理表格 */
  RAIL_INQUIRY_TABLE = 230,
  /** 整箱运价查询 */
  FCL_RATE_QUERY = 481032,
  /** 拼箱运价查询 */
  LCL_RATE_QUERY = 481033,
  /** 空运运价查询 */
  AIR_RATE_QUERY = 481034,
  /** 整箱运价查询表格 */
  FCL_RATE_QUERY_TABLE = 481181,
  /** 拼箱运价查询表格 */
  LCL_RATE_QUERY_TABLE = 481182,
  /** 空运运价查询表格 */
  AIR_RATE_QUERY_TABLE = 481183,
  /** 港前运价查询 */
  PREPORT_RATE_QUERY = 481196,
  /** 港前运价查询表格 */
  PREPORT_RATE_QUERY_TABLE = 481210,
  /** 尾程运价查询 */
  LAST_MILE_RATE_QUERY = 481236,
  /** 尾程运价查询表格 */
  LAST_MILE_RATE_QUERY_TABLE = 481268,
  /** 快递运价查询 */
  EXPRESS_RATE_QUERY = 481282,
  /** 快递运价查询表格 */
  EXPRESS_RATE_QUERY_TABLE = 481296,
  /** 铁路运价查询 */
  RAIL_RATE_QUERY = 481300,
  /** 铁路运价查询表格 */
  RAIL_RATE_QUERY_TABLE = 481301,
  /** 韶音整箱运价查询 */
  SHOKZ_FCL_RATE_QUERY = 481310,
  /** 韶音拼箱运价查询 */
  SHOKZ_LCL_RATE_QUERY = 481311,
  /** 韶音空运运价查询 */
  SHOKZ_AIR_RATE_QUERY = 481312,
  /** 韶音港前运价查询 */
  SHOKZ_PREPORT_RATE_QUERY = 481313,
  /** 韶音尾程运价查询 */
  SHOKZ_LAST_MILE_RATE_QUERY = 481314,
  /** 合约管理表格 */
  CONTRACT_TABLE = 221,
  /** 电商运价管理表格 */
  ECOMMERCE_RATE_TABLE = 65001,
  /** 电商运价置顶 */
  ECOMMERCE_RATE_PIN_TOP = 65002,
  /** 电商运价监控筛选条件 */
  ECOMMERCE_MONITOR_QUERY = 65003,
  /** 电商运价监控表格 */
  ECOMMERCE_MONITOR_TABLE = 65004,
  /** 整箱附加费-海运附加费维护筛选条件 */
  ADDITIONAL_FEE_FCL_OCEAN_FREIGHT = 65132,
  /** 整箱附加费-起运港费用费维护筛选条件 */
  ADDITIONAL_FEE_FCL_POL = 65133,
  /** 整箱附加费-目的港费用维护筛选条件 */
  ADDITIONAL_FEE_FCL_POD = 65134,
  /** 港前附加费维护筛选条件 */
  ADDITIONAL_FEE_PRE_PORT = 65135,
  /** 尾程附加费维护筛选条件 */
  ADDITIONAL_FEE_LAST_MILE = 65136,
  /** 快递附加费维护筛选条件 */
  ADDITIONAL_FEE_EXPRESS = 65137,
  /** 铁路附加费维护筛选条件 */
  ADDITIONAL_FEE_RAIL = 65169,
  /** 整箱附加费-海运附加费维护表格列配置 */
  ADDITIONAL_FEE_FCL_OCEAN_FREIGHT_TABLE = 65158,
  /** 整箱附加费-起运港费用维护表格列配置 */
  ADDITIONAL_FEE_FCL_POL_TABLE = 65159,
  /** 整箱附加费-目的港费用维护表格列配置 */
  ADDITIONAL_FEE_FCL_POD_TABLE = 65160,
  /** 拼箱附加费-海运附加费维护筛选条件 */
  ADDITIONAL_FEE_LCL_OCEAN_FREIGHT = 65161,
  /** 拼箱附加费-起运港费用维护筛选条件 */
  ADDITIONAL_FEE_LCL_POL = 65162,
  /** 拼箱附加费-目的港费用维护筛选条件 */
  ADDITIONAL_FEE_LCL_POD = 65163,
  /** 拼箱附加费-海运附加费维护表格列配置 */
  ADDITIONAL_FEE_LCL_OCEAN_FREIGHT_TABLE = 65164,
  /** 拼箱附加费-起运港费用维护表格列配置 */
  ADDITIONAL_FEE_LCL_POL_TABLE = 65165,
  /** 拼箱附加费-目的港费用维护表格列配置 */
  ADDITIONAL_FEE_LCL_POD_TABLE = 65166,
  /** 空运附加费维护筛选条件 */
  ADDITIONAL_FEE_AIR = 65167,
  /** 空运附加费维护表格列配置 */
  ADDITIONAL_FEE_AIR_TABLE = 65168,
  /** 港前附加费维护表格列配置 */
  ADDITIONAL_FEE_PRE_PORT_TABLE = 66161,
  /** 尾程附加费维护表格列配置 */
  ADDITIONAL_FEE_LAST_MILE_TABLE = 66162,
  /** 快递附加费维护表格列配置 */
  ADDITIONAL_FEE_EXPRESS_TABLE = 66163,
  /** 运价查询组合方案整箱表格列配置 */
  PRICE_QUERY_COMBINATION_TABLE_FCL = 65385,
  /** 运价查询组合方案港前表格列配置 */
  PRICE_QUERY_COMBINATION_TABLE_PREPORT = 65502,
  /** 运价查询组合方案尾程表格列配置 */
  PRICE_QUERY_COMBINATION_TABLE_LAST_MILE = 65516,
  /** 航线维护查询条件 */
  LINE_MAINTENANCE = 327730,
  /** 整箱加价规则筛选条件 */
  INCREASE_RULES_FCL = 684130,
  /** 整箱加价规则表格列配置 */
  INCREASE_RULES_TABLE_FCL = 684174,
  /** 港前加价规则筛选条件 */
  INCREASE_RULES_PREPORT = 684386,
  /** 港前加价规则表格列配置 */
  INCREASE_RULES_TABLE_PREPORT = 684414,
  /** 尾程加价规则筛选条件 */
  INCREASE_RULES_LAST_MILE = 684422,
  /** 尾程加价规则表格列配置 */
  INCREASE_RULES_TABLE_LAST_MILE = 684430,
  /** 商务加价规则-海运整箱-筛选条件 */
  BUSINESS_INCREASE_RULES_FCL = 684500,
  /** 商务加价规则-海运整箱-表格列配置 */
  BUSINESS_INCREASE_RULES_TABLE_FCL = 684520,
  /** 销售加价规则-筛选条件 */
  SALES_INCREASE_RULES = 684540,
  /** 销售加价规则-表格列配置 */
  SALES_INCREASE_RULES_TABLE = 684560,
  /** 海运订单查询条件/表格列配置（老版订单列表） */
  SEA_FREIGHT_ORDER = 229175,
  /** 车架号查询 */
  CHASSIS_QUERY = 229200,
  /** 车架号查询表格 */
  CHASSIS_QUERY_TABLE = 229201,
  /** 报价记录-海运整箱-筛选条件 */
  SALES_QUOTATION_FCL = 229310,
  /** 报价记录-海运整箱-表格列配置 */
  SALES_QUOTATION_FCL_TABLE = 229311,
  /** 发货申请单查询条件 */
  DISTRIBUTION_SHIPMENT = 229210,
  /** 发货申请单表格 */
  DISTRIBUTION_SHIPMENT_TABLE = 229211,
  /** 发货申请单费用页签列显隐偏好 */
  DISTRIBUTION_SHIPMENT_FEE_COLUMNS = 229212,
  /** 运价库整箱筛选条件 */
  FCL_RATE_WAREHOUSE = 730001,
  /** 运价库整箱表格列配置 */
  FCL_RATE_WAREHOUSE_TABLE = 730002,
  /** 运价库拼箱筛选条件 */
  LCL_RATE_WAREHOUSE = 730003,
  /** 运价库拼箱表格列配置 */
  LCL_RATE_WAREHOUSE_TABLE = 730004,
  /** 运价库空运筛选条件 */
  AIR_RATE_WAREHOUSE = 730005,
  /** 运价库空运表格列配置 */
  AIR_RATE_WAREHOUSE_TABLE = 730006,
  /** 运价库尾程筛选条件 */
  LASTMILE_RATE_WAREHOUSE = 730007,
  /** 运价库尾程表格列配置 */
  LASTMILE_RATE_WAREHOUSE_TABLE = 730008,
  /** 运价库港前筛选条件 */
  PRE_PORT_RATE_WAREHOUSE = 730009,
  /** 运价库港前表格列配置 */
  PRE_PORT_RATE_WAREHOUSE_TABLE = 730010,
  PRODUCT_MATERIAL_PRODUCT = 735001,
  PRODUCT_MATERIAL_MATERIAL = 735002,
  /** 运输计划单筛选条件 */
  TRANSPORT_PLAN = 740001,
  /** 运输计划单表格列配置 */
  TRANSPORT_PLAN_TABLE = 740002,
  /** 运输委托单筛选条件 */
  TRANSPORT_CONSIGNMENT = 740003,
  /** 运输委托单表格列配置 */
  TRANSPORT_CONSIGNMENT_TABLE = 740004,
  /** 运输委托单商品明细筛选条件 */
  TRANSPORT_CONSIGNMENT_PRODUCT = 740005,
  /** 运输委托单商品明细表格列配置 */
  TRANSPORT_CONSIGNMENT_PRODUCT_TABLE = 740006,
  /** 供应商合同筛选条件 */
  SUPPLIER_CONTRACT = 740009,
  /** 供应商合同表格列配置 */
  SUPPLIER_CONTRACT_TABLE = 740010,
  /** 运单筛选条件 */
  WAYBILL = 740007,
  /** 运单表格列配置 */
  WAYBILL_TABLE = 740008,
  /** 文控资料列表表格列配置 */
  DOCUMENT_CONTROL_TABLE = 740011,
  /** 运输委托单导入报告表格列配置 */
  TRANSPORT_CONSIGNMENT_IMPORT_REPORT_TABLE = 740012,
  /** 报告中心运输委托单共享筛选条件 */
  REPORT_CENTER_TRANSPORT_FILTER = 740013,
  /** 报告中心运输委托单管理视角表格列方案 */
  REPORT_CENTER_TRANSPORT_MANAGEMENT_TABLE = 740014,
  /** 报告中心运输委托单跟单视角表格列方案 */
  REPORT_CENTER_TRANSPORT_FOLLOW_UP_TABLE = 740015,
  /** 运输委托单费用页签列显隐偏好 */
  TRANSPORT_CONSIGNMENT_FEE_COLUMNS = 740016,
  /** 招标管理高级筛选 */
  TENDER_MANAGEMENT = 750001,
  /** 招标管理表格列配置 */
  TENDER_MANAGEMENT_TABLE = 750002,
  /** 招标评标页高级筛选 */
  BIDDING_EVALUATION = 750003,
  /** 结算账单-对账列表 */
  SETTLEMENT_RECONCILIATION_TABLE = 760001,
  /** 结算账单-账单列表 */
  SETTLEMENT_BILL_TABLE = 760002,
  /** 海外仓库管理表格 */
  OVERSEAS_WAREHOUSE_TABLE = 760003,
  /** 费用管理表格 */
  FEE_MANAGEMENT_TABLE = 760004
}

/**
 * 模块名称映射
 */
export const MODULE_NAMES: Record<UiConfigModule, string> = {
  [UiConfigModule.FCL_RATE]: '整箱运价管理',
  [UiConfigModule.LCL_RATE]: '拼箱运价管理',
  [UiConfigModule.EXPRESS_RATE]: '快递运价管理',
  [UiConfigModule.AIR_RATE]: '空运运价管理',
  [UiConfigModule.LAST_MILE_RATE]: '尾程运价管理',
  [UiConfigModule.ECOMMERCE_RATE]: '电商运价管理',
  [UiConfigModule.PREPORT_RATE]: '港前运价管理',
  [UiConfigModule.RATE_QUERY]: '运价查询',
  [UiConfigModule.INQUIRY]: '询价管理',
  [UiConfigModule.QUOTE]: '报价管理',
  [UiConfigModule.SURCHARGE]: '附加费管理',
  [UiConfigModule.PRICING_RULE]: '定价规则管理',
  [UiConfigModule.CONTRACT]: '合同管理',
  [UiConfigModule.ORDER]: '订单管理',
  [UiConfigModule.ORDER_DETAIL]: '订单详情',
  [UiConfigModule.ORDER_INQUIRY]: '订单询价',
  [UiConfigModule.USER]: '用户管理',
  [UiConfigModule.COMPANY]: '公司管理',
  [UiConfigModule.PERMISSION]: '权限管理',
  [UiConfigModule.FCL_RATE_TABLE]: '整箱运价管理表格',
  [UiConfigModule.LCL_RATE_TABLE]: '拼箱运价管理表格',
  [UiConfigModule.AIR_RATE_TABLE]: '空运运价管理表格',
  [UiConfigModule.LAST_MILE_RATE_TABLE]: '尾程运价管理表格',
  [UiConfigModule.PREPORT_RATE_TABLE]: '港前运价管理表格',
  [UiConfigModule.ONCARRIAGE_RATE_TABLE]: '公路运价管理表格',
  [UiConfigModule.INQUIRY_TABLE]: '询价管理表格',
  [UiConfigModule.ORDER_TABLE]: '订单管理表格',
  [UiConfigModule.USER_TABLE]: '用户管理表格',
  [UiConfigModule.COMPANY_TABLE]: '公司管理表格',
  [UiConfigModule.BILLING_TABLE]: '账单管理表格',
  [UiConfigModule.CONTRACT_TABLE]: '合约管理表格',
  [UiConfigModule.ECOMMERCE_RATE_TABLE]: '电商运价管理表格',
  [UiConfigModule.ECOMMERCE_RATE_PIN_TOP]: '电商运价置顶',
  [UiConfigModule.ECOMMERCE_MONITOR_QUERY]: '电商运价监控筛选条件',
  [UiConfigModule.ECOMMERCE_MONITOR_TABLE]: '电商运价监控表格',
  [UiConfigModule.FCL_INQUIRY_TABLE]: '整箱询价管理表格',
  [UiConfigModule.LCL_INQUIRY_TABLE]: '拼箱询价管理表格',
  [UiConfigModule.AIR_INQUIRY_TABLE]: '空运询价管理表格',
  [UiConfigModule.PREPORT_INQUIRY_TABLE]: '港前询价管理表格',
  [UiConfigModule.LASTMILE_INQUIRY_TABLE]: '尾程询价管理表格',
  [UiConfigModule.FCL_QUOTATION_TABLE]: '整箱报价管理表格',
  [UiConfigModule.LCL_QUOTATION_TABLE]: '拼箱报价管理表格',
  [UiConfigModule.AIR_QUOTATION_TABLE]: '空运报价管理表格',
  [UiConfigModule.PREPORT_QUOTATION_TABLE]: '港前报价管理表格',
  [UiConfigModule.LAST_MILE_QUOTATION_TABLE]: '尾程报价管理表格',
  [UiConfigModule.EXPRESS_RATE_TABLE]: '快递运价管理表格',
  [UiConfigModule.EXPRESS_INQUIRY_TABLE]: '快递询价管理表格',
  [UiConfigModule.RAIL_INQUIRY_TABLE]: '铁路询价管理表格',
  [UiConfigModule.RAIL_RATE]: '铁路运价维护',
  [UiConfigModule.FCL_RATE_QUERY]: '整箱运价查询',
  [UiConfigModule.LCL_RATE_QUERY]: '拼箱运价查询',
  [UiConfigModule.AIR_RATE_QUERY]: '空运运价查询',
  [UiConfigModule.FCL_RATE_QUERY_TABLE]: '整箱运价查询表格',
  [UiConfigModule.LCL_RATE_QUERY_TABLE]: '拼箱运价查询表格',
  [UiConfigModule.AIR_RATE_QUERY_TABLE]: '空运运价查询表格',
  [UiConfigModule.PREPORT_RATE_QUERY]: '港前运价查询',
  [UiConfigModule.PREPORT_RATE_QUERY_TABLE]: '港前运价查询表格',
  [UiConfigModule.LAST_MILE_RATE_QUERY]: '尾程运价查询',
  [UiConfigModule.LAST_MILE_RATE_QUERY_TABLE]: '尾程运价查询表格',
  [UiConfigModule.EXPRESS_RATE_QUERY]: '快递运价查询',
  [UiConfigModule.EXPRESS_RATE_QUERY_TABLE]: '快递运价查询表格',
  [UiConfigModule.RAIL_RATE_QUERY]: '铁路运价查询',
  [UiConfigModule.RAIL_RATE_QUERY_TABLE]: '铁路运价查询表格',
  [UiConfigModule.SHOKZ_FCL_RATE_QUERY]: '韶音整箱运价查询',
  [UiConfigModule.SHOKZ_LCL_RATE_QUERY]: '韶音拼箱运价查询',
  [UiConfigModule.SHOKZ_AIR_RATE_QUERY]: '韶音空运运价查询',
  [UiConfigModule.SHOKZ_PREPORT_RATE_QUERY]: '韶音港前运价查询',
  [UiConfigModule.SHOKZ_LAST_MILE_RATE_QUERY]: '韶音尾程运价查询',
  [UiConfigModule.ADDITIONAL_FEE_FCL_OCEAN_FREIGHT]: '整箱附加费-海运附加费维护筛选条件',
  [UiConfigModule.ADDITIONAL_FEE_FCL_POL]: '整箱附加费-起运港费用维护筛选条件',
  [UiConfigModule.ADDITIONAL_FEE_FCL_POD]: '整箱附加费-目的港费用维护筛选条件',
  [UiConfigModule.ADDITIONAL_FEE_PRE_PORT]: '港前附加费维护筛选条件',
  [UiConfigModule.ADDITIONAL_FEE_LAST_MILE]: '尾程附加费维护筛选条件',
  [UiConfigModule.ADDITIONAL_FEE_EXPRESS]: '快递附加费维护筛选条件',
  [UiConfigModule.ADDITIONAL_FEE_RAIL]: '铁路附加费维护筛选条件',
  [UiConfigModule.ADDITIONAL_FEE_FCL_OCEAN_FREIGHT_TABLE]: '整箱附加费-海运附加费维护表格列配置',
  [UiConfigModule.ADDITIONAL_FEE_FCL_POL_TABLE]: '整箱附加费-起运港费用维护表格列配置',
  [UiConfigModule.ADDITIONAL_FEE_FCL_POD_TABLE]: '整箱附加费-目的港费用维护表格列配置',
  [UiConfigModule.ADDITIONAL_FEE_LCL_OCEAN_FREIGHT]: '拼箱附加费-海运附加费维护筛选条件',
  [UiConfigModule.ADDITIONAL_FEE_LCL_POL]: '拼箱附加费-起运港费用维护筛选条件',
  [UiConfigModule.ADDITIONAL_FEE_LCL_POD]: '拼箱附加费-目的港费用维护筛选条件',
  [UiConfigModule.ADDITIONAL_FEE_LCL_OCEAN_FREIGHT_TABLE]: '拼箱附加费-海运附加费维护表格列配置',
  [UiConfigModule.ADDITIONAL_FEE_LCL_POL_TABLE]: '拼箱附加费-起运港费用维护表格列配置',
  [UiConfigModule.ADDITIONAL_FEE_LCL_POD_TABLE]: '拼箱附加费-目的港费用维护表格列配置',
  [UiConfigModule.ADDITIONAL_FEE_AIR]: '空运附加费维护筛选条件',
  [UiConfigModule.ADDITIONAL_FEE_AIR_TABLE]: '空运附加费维护表格列配置',
  [UiConfigModule.ADDITIONAL_FEE_PRE_PORT_TABLE]: '港前附加费维护表格列配置',
  [UiConfigModule.ADDITIONAL_FEE_LAST_MILE_TABLE]: '尾程附加费维护表格列配置',
  [UiConfigModule.ADDITIONAL_FEE_EXPRESS_TABLE]: '快递附加费维护表格列配置',
  [UiConfigModule.PRICE_QUERY_COMBINATION_TABLE_FCL]: '运价查询组合方案整箱表格列配置',
  [UiConfigModule.PRICE_QUERY_COMBINATION_TABLE_PREPORT]: '运价查询组合方案港前表格列配置',
  [UiConfigModule.PRICE_QUERY_COMBINATION_TABLE_LAST_MILE]: '运价查询组合方案尾程表格列配置',
  [UiConfigModule.LINE_MAINTENANCE]: '航线维护查询条件',
  [UiConfigModule.INCREASE_RULES_FCL]: '整箱加价规则筛选条件',
  [UiConfigModule.INCREASE_RULES_TABLE_FCL]: '整箱加价规则表格列',
  [UiConfigModule.INCREASE_RULES_PREPORT]: '港前加价规则筛选条件',
  [UiConfigModule.INCREASE_RULES_TABLE_PREPORT]: '港前加价规则表格列配置',
  [UiConfigModule.INCREASE_RULES_LAST_MILE]: '尾程加价规则筛选条件',
  [UiConfigModule.INCREASE_RULES_TABLE_LAST_MILE]: '尾程加价规则表格列配置',
  [UiConfigModule.BUSINESS_INCREASE_RULES_FCL]: '商务加价规则-海运整箱-筛选条件',
  [UiConfigModule.BUSINESS_INCREASE_RULES_TABLE_FCL]: '商务加价规则-海运整箱-表格列配置',
  [UiConfigModule.SALES_INCREASE_RULES]: '销售加价规则-筛选条件',
  [UiConfigModule.SALES_INCREASE_RULES_TABLE]: '销售加价规则-表格列配置',
  [UiConfigModule.SEA_FREIGHT_ORDER]: '海运订单查询条件',
  [UiConfigModule.CHASSIS_QUERY]: '车架号查询',
  [UiConfigModule.CHASSIS_QUERY_TABLE]: '车架号查询表格',
  [UiConfigModule.SALES_QUOTATION_FCL]: '报价记录-海运整箱-筛选条件',
  [UiConfigModule.SALES_QUOTATION_FCL_TABLE]: '报价记录-海运整箱-表格列配置',
  [UiConfigModule.DISTRIBUTION_SHIPMENT]: '发货申请单查询条件',
  [UiConfigModule.DISTRIBUTION_SHIPMENT_TABLE]: '发货申请单表格',
  get [UiConfigModule.DISTRIBUTION_SHIPMENT_FEE_COLUMNS]() {
    return t('transportConsignment.detail.feeColumns.shipmentModule')
  },
  [UiConfigModule.FCL_RATE_WAREHOUSE]: '运价库整箱筛选条件',
  [UiConfigModule.FCL_RATE_WAREHOUSE_TABLE]: '运价库整箱表格列配置',
  [UiConfigModule.LCL_RATE_WAREHOUSE]: '运价库拼箱筛选条件',
  [UiConfigModule.LCL_RATE_WAREHOUSE_TABLE]: '运价库拼箱表格列配置',
  [UiConfigModule.AIR_RATE_WAREHOUSE]: '运价库空运筛选条件',
  [UiConfigModule.AIR_RATE_WAREHOUSE_TABLE]: '运价库空运表格列配置',
  [UiConfigModule.LASTMILE_RATE_WAREHOUSE]: '运价库尾程筛选条件',
  [UiConfigModule.LASTMILE_RATE_WAREHOUSE_TABLE]: '运价库尾程表格列配置',
  [UiConfigModule.PRE_PORT_RATE_WAREHOUSE]: '运价库港前筛选条件',
  [UiConfigModule.PRE_PORT_RATE_WAREHOUSE_TABLE]: '运价库港前表格列配置',
  [UiConfigModule.PRODUCT_MATERIAL_PRODUCT]: '产品物料数据-产品筛选条件',
  [UiConfigModule.PRODUCT_MATERIAL_MATERIAL]: '产品物料数据-物料筛选条件',
  [UiConfigModule.TRANSPORT_PLAN]: '运输计划单筛选条件',
  [UiConfigModule.TRANSPORT_PLAN_TABLE]: '运输计划单表格列配置',
  [UiConfigModule.TRANSPORT_CONSIGNMENT]: '运输委托单筛选条件',
  [UiConfigModule.TRANSPORT_CONSIGNMENT_TABLE]: '运输委托单表格列配置',
  get [UiConfigModule.TRANSPORT_CONSIGNMENT_FEE_COLUMNS]() {
    return t('transportConsignment.detail.feeColumns.consignmentModule')
  },
  [UiConfigModule.TRANSPORT_CONSIGNMENT_PRODUCT]: '运输委托单商品明细筛选条件',
  [UiConfigModule.TRANSPORT_CONSIGNMENT_PRODUCT_TABLE]: '运输委托单商品明细表格列配置',
  [UiConfigModule.SUPPLIER_CONTRACT]: '供应商合同筛选条件',
  [UiConfigModule.SUPPLIER_CONTRACT_TABLE]: '供应商合同表格列配置',
  [UiConfigModule.WAYBILL]: '运单筛选条件',
  [UiConfigModule.WAYBILL_TABLE]: '运单表格列配置',
  [UiConfigModule.DOCUMENT_CONTROL_TABLE]: '文控资料表格列配置',
  [UiConfigModule.TRANSPORT_CONSIGNMENT_IMPORT_REPORT_TABLE]: '运输委托单导入报告表格列配置',
  // 报告中心名称在读取时翻译，确保切换语言后同步更新。
  get [UiConfigModule.REPORT_CENTER_TRANSPORT_FILTER]() {
    return t('reportCenter.configModules.filter')
  },
  get [UiConfigModule.REPORT_CENTER_TRANSPORT_MANAGEMENT_TABLE]() {
    return t('reportCenter.configModules.managementTable')
  },
  get [UiConfigModule.REPORT_CENTER_TRANSPORT_FOLLOW_UP_TABLE]() {
    return t('reportCenter.configModules.followUpTable')
  },
  [UiConfigModule.TENDER_MANAGEMENT]: '招标管理高级筛选',
  [UiConfigModule.TENDER_MANAGEMENT_TABLE]: '招标管理表格列配置',
  [UiConfigModule.BIDDING_EVALUATION]: '招标评标页高级筛选',
  [UiConfigModule.SETTLEMENT_RECONCILIATION_TABLE]: '结算账单-对账列表',
  [UiConfigModule.SETTLEMENT_BILL_TABLE]: '结算账单-账单列表',
  [UiConfigModule.OVERSEAS_WAREHOUSE_TABLE]: '海外仓库管理表格',
  [UiConfigModule.FEE_MANAGEMENT_TABLE]: '费用管理表格'
}

/**
 * 获取模块名称
 * @param moduleId 模块ID
 * @returns 模块名称
 */
export function getModuleName(moduleId: UiConfigModule): string {
  return MODULE_NAMES[moduleId] || `未知模块(${moduleId})`
}

/**
 * 获取所有模块选项（用于下拉框等组件）
 * @returns 模块选项数组
 */
export function getModuleOptions(): Array<{ label: string; value: UiConfigModule }> {
  return Object.entries(MODULE_NAMES).map(([value, label]) => ({
    label,
    value: Number(value) as UiConfigModule
  }))
}

/**
 * 检查是否为有效的模块ID
 * @param moduleId 模块ID
 * @returns 是否有效
 */
export function isValidModule(moduleId: number): moduleId is UiConfigModule {
  return Object.values(UiConfigModule).includes(moduleId as UiConfigModule)
}
